module.exports = __webpack_public_path__ + "static/lframe-home-gem-nz-cf412695f40e3d8c1248db731417edd3.png";